module.exports = __webpack_public_path__ + "media/images/admin/icons/more-vertical-4cad70953b302c2ee888bebb7b319618.svg";